import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import BaseChart from '@components/common/Charts/BaseChart';

export const SpiWidgetWrapper = styled.div`
  width:49%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  min-width: 300px;
  margin-right: 5px;
  margin-bottom: 5px;
  padding: 10px;
  box-sizing: border-box;
  flex-wrap: wrap;
`;

export const MetricNumbersTextWrapper = styled.div`
  align-items: flex-start;
  align-items: center;
  margin-top: 0px;
  justify-content: space-between;
  height: 70px;
  display: flex;
  flex-direction: row;
`;

export const BenchmarkValue = styled.span`
  font-weight: 600;
`;

export const TextDivider = styled.div`
  background: #979797;
  opacity: 0.5;
  margin: 5px 0px;
  height: 1px;
`;

export const TextContainer = styled.div`
  display: flex;
  padding: 15px 10px 10px 0px;
  box-sizing: border-box;
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

export const IconHolder = styled.div`
  font-size: 1.5rem;
  box-sizing: border-box;
  cursor: pointer;
  width: 25px;
`;

export const PopUpMetric = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 20px;
  box-sizing: border-box;

  ${breakpoint('desktop')`
      font-size: 16px;
      width: 100%;
  `};

  ${breakpoint('tablet')`
      font-size: 16px;
      width: 100%;
  `};

  ${breakpoint('mobile')`
      font-size: 14px;
      width: 90%;
  `};

  .ant-input-disabled {
    background-color: #EFEFEF !important;
    border: 1px solid #9B9B9B;
    color: #9B9B9B !important;
    width: 80px !important;
  }
  .ant-modal-header{
    font-weight: 600;
    font-size: 20px;
    line-height: 30px;
  }
`;

export const MetricUnit = styled.div`
  width: 35%;
  display: flex;
  color: #9B9B9B;
`;

export const SPIStyle = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #4A4A4A;
`;

export const SPIMetricsDropDown = styled.div`
  padding-top: 15px;
  padding-bottom: 20px;
  width: 100%;
`;

export const SPIThresholdsContainer = styled.div`{
  margin-top: 15px;
  margin-bottom: 20px;
  border: 1px solid #9B9B9B;
  box-sizing: border-box;
  border-radius: 6px;
  padding: 20px 15px 0px 15px;
}`;
export const MetricName = styled.div`
  width: 65%;
  font-weight: 300;
  line-height: 22px;
`;

export const MetricSign = styled.div`{
  padding: 0px 5px;
  Font-weight: 300;
  font-size: 16px;
  color: black;
  line-height: 2;
}`

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const AverageContainer =  styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
`;

export const StreamsContainer =  styled.div`
  display: flex;
  align-items: flex-end;
`;

export const StreamsText = styled.div`
  font-size: 15px;
  font-weight: 600;
  padding-left: 15px;
`;
export const Numbers = styled.div`
  font-size: 16px;
  min-width: 50px;
`;

export const AverageText = styled.div`
  font-size: 14px;
  padding-left: 15px;
  font-weight: 300;
`;

export const StreamsWrapper = styled.div`
  height: 100px;
  margin-left: 15px;
`;

export const SPIChartScore = styled.div`
  display: flex;
  height: 80px;
  cursor: pointer;
  align-self: left;
`;

export const GaugeChart = styled.div`
  padding-top: 12px;
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;
  padding: 0px 3px;
  cursor: pointer;
  height: 100px;
  &.streams-tab:hover, &.selected {
    background-color: #e9f3fd;
  }
`;

export const InfoBox = styled.div`
  display: inline-block;
  font-weight: bold;
  font-size: 1.1em;
`;
export const InfoText = styled.div`
  margin-left: 10px;
  display: inline-block;
`;

export const Divider = styled.div`
  display: inline-block;
  width: 1px;
  height: 1em;
  margin: 0px 8px;
  background-color: #e9edf0;
`;

export const TabWrapper = styled.div`
    border: none;
    position: relative;
    .ant-tabs-bar {
      border-bottom: 0;
    }
    min-height: 120px;
    margin-bottom:5px;
    .ant-tabs-nav-list {
      .ant-tabs-tab {
        margin: 0 32px 0 0;
      }
    }
`;

export const InfoProgress = styled.div`
    width: 100%;
`;

export const InfoPct = styled.div`
  font-size: 0.9em;
`
export const IconWrap = styled.div`
  display: inline-block;
  vertical-align: middle;
  margin-right: 2px;
`;

export const PctWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-content: flex-start;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  width: 100%;
`;

export const StyledBaseChart = styled(BaseChart)`
  box-sizing: border-box;
  width: 100%;
  height: 100px;
`;

export const BenchmarkContentWrapper = styled.div`
    display: flex;
    flex-shrink: 1;
    flex-direction: column;
    font-size: 1em;
`;

export const BenchmarkWrapper = styled.div`
  margin: 5px;
`;

export const BenchmarkTextWrapper = styled.span`
  margin-right: 5px;
`;

export const BenchmarkValueWrapper = styled.span`
  color: #0046FF;
  background-color: #F8F8F8;
  padding: 5px;
  font-weight: 1000;
`;
